import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function NewsletterSubscribe() {
  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/newsletter/subscribe`, formData);
      toast.success('Successfully subscribed to newsletter!');
      setFormData({ email: '', first_name: '', last_name: '' });
    } catch (error) {
      console.error('Newsletter subscription failed:', error);
      toast.error(error.response?.data?.detail || 'Subscription failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">
        NEWSLETTER
      </h4>
      <p className="text-sm text-muted-foreground mb-4">
        Subscribe to receive updates about new works and exhibitions
      </p>
      <form onSubmit={handleSubmit} className="space-y-3">
        <Input
          type="text"
          placeholder="First Name"
          value={formData.first_name}
          onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
          required
          className="bg-background"
          data-testid="newsletter-first-name"
        />
        <Input
          type="text"
          placeholder="Last Name"
          value={formData.last_name}
          onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
          required
          className="bg-background"
          data-testid="newsletter-last-name"
        />
        <Input
          type="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
          className="bg-background"
          data-testid="newsletter-email"
        />
        <Button
          type="submit"
          disabled={loading}
          className="w-full rounded-full text-xs uppercase tracking-widest"
          data-testid="newsletter-submit"
        >
          {loading ? 'SUBSCRIBING...' : 'SUBSCRIBE'}
        </Button>
      </form>
    </div>
  );
}
